export const CIRCLE_LINK_RADIUS = 30;
